var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 1024 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480.226 274-66.358 147.627L347.796 274h-84.698v211.936L168.777 274H97.322L1 494.082h56.974l21.103-49.161h107.897l21.341 49.161h108.851V330.64l72.169 163.442h49.162l73.932-160.631v160.631h54.02V274h-86.223ZM99.466 397.379l32.249-76.933 33.537 76.933H99.465ZM925.505 381.612l96.755-107.136h-68.744l-61.928 68.312-59.88-68.74H618.724V494.13h206.029l64.882-72.741 63.309 73.217h68.506l-95.945-112.994Zm-128.953 66.31h-124.57V404.43h119.187v-41.825H671.982v-41.206l131.478.333 52.591 59.927-59.499 66.263Z",
    fill: "#1D8ECE"
  })));
};
export default SvgAmex;